// src/hooks/currencies/useForceDeleteCurrency.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteCurrency } from "../../api/apiCurrencies";
import { useTranslation } from "react-i18next";

function useForceDeleteCurrency() {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng === "ar";

    const { mutate: forceDeleteCurrencyMutation, isPending: isForceDelete } = useMutation({
        mutationFn: forceDeleteCurrency,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["currencies"] });
            toast.success(isArabic ? "تم حذف العملة نهائياً" : "Currency permanently deleted");
        },
        onError: (err) => {
            toast.error(err?.message || (isArabic ? "فشل في الحذف النهائي" : "Failed to force delete currency"));
        },
    });

    return { forceDeleteCurrency: forceDeleteCurrencyMutation, isForceDelete };
}

export default useForceDeleteCurrency;
